export enum GDPRConsentEnum {
  DOT_DIGITAL = 'DOT_DIGITAL',
  ATOZ_NEWS = 'ATOZ_NEWS',
  ATOZ_EVENTS = 'ATOZ_EVENTS',
  DEVECO_NEWS = 'DEVECO_NEWS',
  DEVECO_EVENTS = 'DEVECO_EVENTS',
  ESG = 'ESG'
}

export enum GDPRConsentFilterEnum {
  ATOZ_NEWS = 'ATOZ_NEWS',
  ATOZ_EVENTS = 'ATOZ_EVENTS',
  DEVECO_NEWS = 'DEVECO_NEWS',
  DEVECO_EVENTS = 'DEVECO_EVENTS',
  DECLINED_DOT_DIGITAL = 'DECLINED_DOT_DIGITAL',
  DECLINED_ESG = 'DECLINED_ESG'
}

export enum GDPRConsentLabel {
  DOT_DIGITAL = 'Dotdigital consent',
  ATOZ_NEWS = 'News from ATOZ',
  DEVECO_NEWS = 'News from Deveco',
  ATOZ_EVENTS = 'Event invitations from ATOZ',
  DEVECO_EVENTS = 'Event invitations from Deveco',
  ESG = 'ESG consent',
  DECLINED_DOT_DIGITAL = 'Dotdigital declined',
  DECLINED_ESG = 'ESG declined'
}
